export const getAuthErrorTitle = (authError = {}) => {
	const code = authError?.code || '';
	return authErrorCodes[code]?.title || 'Error';
}

export const getAuthErrorText = (authError = {}) => {
	const code = authError?.code || '';
	return authErrorCodes[code]?.text || authError?.message || '';
}

const authErrorCodes = {
	USER_NOT_FOUND: { title: '', text: 'User not found.' },
	FAILED_TO_CREATE_USER: { title: '', text: 'Failed to create user.' },
	FAILED_TO_CREATE_SESSION: { title: '', text: 'Failed to create session.' },
	FAILED_TO_UPDATE_USER: { title: '', text: 'Failed to update user.' },
	FAILED_TO_GET_SESSION: { title: '', text: 'Failed to get session.' },
	INVALID_PASSWORD: { title: '', text: 'Invalid password.' },
	INVALID_EMAIL: { title: '', text: 'Invalid email.' },
	INVALID_EMAIL_OR_PASSWORD: { title: '', text: 'Invalid email or password.' },
	SOCIAL_ACCOUNT_ALREADY_LINKED: { title: '', text: 'Social account already linked.' },
	PROVIDER_NOT_FOUND: { title: '', text: 'Provider not found.' },
	INVALID_TOKEN: { title: '', text: 'Invalid token.' },
	ID_TOKEN_NOT_SUPPORTED: { title: '', text: 'id_token not supported.' },
	FAILED_TO_GET_USER_INFO: { title: '', text: 'Failed to get user info.' },
	USER_EMAIL_NOT_FOUND: { title: '', text: 'User email not found.' },

	EMAIL_NOT_VERIFIED: { title: 'Email is not verified.', text: 'Please check your inbox and verify your email to continue.' },

	PASSWORD_TOO_SHORT: { title: '', text: 'Password too short.' },
	PASSWORD_TOO_LONG: { title: '', text: 'Password too long.' },
	USER_ALREADY_EXISTS: { title: '', text: 'User already exists.' },
	EMAIL_CAN_NOT_BE_UPDATED: { title: '', text: 'Email can not be updated.' },
	CREDENTIAL_ACCOUNT_NOT_FOUND: { title: '', text: 'Credential account not found.' },
	SESSION_EXPIRED: { title: '', text: 'Session expired. Re-authenticate to perform this action.' },
	FAILED_TO_UNLINK_LAST_ACCOUNT: { title: "", text: "You can't unlink your last account." },
	ACCOUNT_NOT_FOUND: { title: '', text: 'Account not found.' },
};